import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step2 } from '../../../../shared/models/component-messages/mapaAN/step2';
import { TypeLieu } from '../models/TypeLieu';
@Component({
  selector: 'app-type-lieu',
  templateUrl: './type-lieu.component.html'
})
export class TypeLieuComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeLieu'
  @Input() parentForm: FormGroup;
  @Input() lieuExecutionLivraison : TypeLieu;
  @Input() rule : string;
  @Input() errorMessage : string;
  @Input() disabled: boolean;

  public step2 = new Step2();

  constructor() { }

  public ngOnInit() {
    if(this.lieuExecutionLivraison == null)
      this.lieuExecutionLivraison = new TypeLieu();
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

